import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Partner } from 'src/app/shared/models/clients/partner';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { cities } from 'src/app/shared/models/cities';
import { countries } from 'src/app/shared/models/countries';

@Component({
  selector: 'app-partners-modal',
  templateUrl: './partners-modal.component.html',
  styleUrls: ['./partners-modal.component.scss']
})
export class PartnersModalComponent implements OnInit {
  public partner: Partner;
  public cities = cities;
  public countries = countries;

  @ViewChild('partnerModal') partnerModal;
  @Output() submit: EventEmitter<Partner> = new EventEmitter<Partner>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(partner: Partner) {
    this.partner = Object.assign(new Partner(), partner);
    this.modalRef = this.modalService.open(this.partnerModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.partner.id) {
      this.spinner.show();
      this.api.updateClientPartner(this.partner.clientId, this.partner).subscribe(
        p => {
          this.spinner.hide();
          this.submit.emit(p);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClientPartner(this.partner.clientId, this.partner).subscribe(
        p => {
          this.spinner.hide();
          this.submit.emit(p);
        }
      )
    }
    this.modalRef.close();
  }

}
